
import { RegisterItem } from '../decorators/snitem-factory-decorator';
import * as moment from 'moment';
import { CNPrescription } from './cnprescription';
import { CNContactService } from './cncontactservice';
import { CNItem } from './cnitem';
import { CNTreatment } from './cntreatment';
import { CNServiceCode } from './cnservicecode';
import { CNHealthAgent } from './cnhealthagent';
import { SNItemFactory } from './snitemfactory';
import { CNDocumentReport } from './cndocumentreport';
import { CNReport } from './cnreport';
import { Subscription } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { CNAnonymousReportRequest } from './cnanonymousreportrequest';

export class ContactServiceRule {
    public first: boolean;
    public all: boolean;
    public from: number;
    public to: number;
    public group: string;
}

export class ContactServiceRules {
    public code: ContactServiceRule[];

    public groupCodeForCount(count: number): string {
        if (!this.code) {
            return undefined;
        }
        let group: string;
        if (count === 1) {
            // search first rule
            const foundCode = this.code.find(aCode => aCode.first);
            if (foundCode) {
                group = foundCode.group;
            }
        }
        if (count > 1) {
            const foundCode = this.code.find(aCode => aCode.from >= count && aCode.to <= count);
            if (foundCode) {
                group = foundCode.group;
            } else {
                // search for all
                const allCode = this.code.find(aCode => aCode.all);
                if (allCode) {
                    group = allCode.group;
                }
            }
        }
        return group;
    }
}

export enum CNConsultationType {
    Simple = 'Simple',
    Kine = 'Kine',
    Logo = 'Logo',
//    SOAP = 'SOAP',
    RX = 'RX',
    Echography = 'Echography',
//    EMG = 'EMG',
    Cardio = 'Cardio',
    Ophtalmo = 'Ophtalmo'
}

export class CNConsultationBiometrics {
    public weight: string;
    public height: string;
    public bmi: string;
    public pulse: string;
    public saturation: string;
    public bloodsugar: string;
    // tslint:disable-next-line:variable-name
    public talyingdown_right1: string;
    // tslint:disable-next-line:variable-name
    public talyingdown_right2: string;
    // tslint:disable-next-line:variable-name
    public talyingdown_left1: string;
    // tslint:disable-next-line:variable-name
    public talyingdown_left2: string;
    // tslint:disable-next-line:variable-name
    public tastanding_right1: string;
    // tslint:disable-next-line:variable-name
    public tastanding_right2: string;
    // tslint:disable-next-line:variable-name
    public tastanding_left1: string;
    // tslint:disable-next-line:variable-name
    public tastanding_left2: string;
    public cranialperimeter: string;
}

export class CNConsultationOphtalmo {
    public motif: string;
    public scavod: string;
    public scavog: string;
    public scbinnoc: string;
    public cplavod: string;
    public cplsphod: string;
    public cplcylod: string;
    public cplaxeod: string;
    public cpladdod: string;
    public cplavog: string;
    public cplsphog: string;
    public cplcylog: string;
    public cplaxeog: string;
    public cpladdog: string;
    public cplbinnoc: string;
    public cppavod: string;
    public cppsphod: string;
    public cppcylod: string;
    public cppaxeod: string;
    public cppavog: string;
    public cppsphog: string;
    public cppcylog: string;
    public cppaxeog: string;
    public cppbinnoc: string;
    public autorefavod: string;
    public autorefsphod: string;
    public autorefcylod: string;
    public autorefaxeod: string;
    public autorefindtransod: string;
    public autorefavog: string;
    public autorefsphog: string;
    public autorefcylog: string;
    public autorefaxeog: string;
    public autorefindtransog: string;
    public autorefbinnoc: string;
    public refslavod: string;
    public refslsphod: string;
    public refslcylod: string;
    public refslaxeod: string;
    public refsladdod: string;
    public refslavog: string;
    public refslsphog: string;
    public refslcylog: string;
    public refslaxeog: string;
    public refsladdog: string;
    public refslbinnoc: string;
    public refspavod: string;
    public refspsphod: string;
    public refspcylod: string;
    public refspaxeod: string;
    public refspavog: string;
    public refspsphog: string;
    public refspcylog: string;
    public refspaxeog: string;
    public refspbinnoc: string;
    public cyclosphod: string;
    public cyclocylod: string;
    public cycloaxeod: string;
    public cyclosphog: string;
    public cyclocylog: string;
    public cycloaxeog: string;
    public remrefod: string;
    public remrefog: string;
    public troustenod: string;
    public troustenog: string;
    public pda: string;
    public prescription: string;
    public prescsphod: string;
    public presccylod: string;
    public prescaxeod: string;
    public prescaddod: string;
    public prescsphog: string;
    public presccylog: string;
    public prescaxeog: string;
    public prescaddog: string;
    public presccorsphod: string;
    public presccorcylod: string;
    public presccoraxeod: string;
    public presccorsphog: string;
    public presccorcylog: string;
    public presccoraxeog: string;
    public presctypeverre: string;
    public presccaractverre: string;
    public lafod: string;
    public lafog: string;
    public food: string;
    public foog: string;
    public k1od: string;
    public k1axeod: string;
    public k2od: string;
    public k2axeod: string;
    public k1og: string;
    public k1axeog: string;
    public k2og: string;
    public k2axeog: string;
    public fodil: string;
    public tioautood: string;
    public tioautoog: string;
    public tioaplaod: string;
    public tioaplaog: string;
    public pachyod: string;
    public pachyog: string;
    public tiocorod: string;
    public tiocorog: string;
    public hto: string;
    public cvod: string;
    public cvog: string;
    public amslerod: string;
    public amslerog: string;
    public excomp: string;
    public diagnostic: string;
    public todo: string;
}

export class CNConsultationCardioComplaints {
    public reason: string;
    public complaints: string;
    public anamesis: string;
}

export class CNConsultationCardioClinicalExam {
    public general: string;
    public heart: string;
    public lungs: string;
    public carotids: string;
    public relux: string;
    public pressure: string;
    public abdomen: string;
    public pulseperif: string;
    public various: string;
}

export class CNConsultationCardioComplementary {
    public exams: string;
    public biology: string;
}

export class CNConsultationCardioConclusion {
    public conclusion: string;
    public treatment: string;
    public followup: string;
}

export class CNConsultationCardio {
    public complaints: CNConsultationCardioComplaints;
    public clinicalexam: CNConsultationCardioClinicalExam;
    public complementaryexam: CNConsultationCardioComplementary;
    public conclusion: CNConsultationCardioConclusion;
}

@RegisterItem('consultation', 'ContactService')
export class CNConsultation extends CNItem {

    private biometricsCache: CNConsultationBiometrics;
    private ophtalmoCache: CNConsultationOphtalmo;
    private cardioCache: CNConsultationCardio;
    private treatmentsCache: CNTreatment[] = [];
    private service: CNContactService;
    public healthagent: CNHealthAgent;
    public prescriptions: CNPrescription[];
    public documents: CNDocumentReport[] | CNReport[];
    public requests: CNAnonymousReportRequest[];

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'stvaast_consultation';
    }

    get checksumChain(): string {
        let propChain = super.checksumChain;
        if (this.biometricsCache) {
            propChain += JSON.stringify(this.biometricsCache);
        }
        if (this.ophtalmoCache) {
            propChain += JSON.stringify(this.ophtalmoCache);
        }
        if (this.service) {
            propChain += JSON.stringify(this.service);
        }
        return propChain;
    }

    set date(consultdate: Date) {
        this.setProperty('date', moment(consultdate).format('DD/MM/YYYY'));
    }

    get date(): Date {
        if (this.getProperty('date')) {
            return moment(this.getProperty('date'), 'DD/MM/YYYY').toDate();
        }
        return this.createddate;
    }

    get isPaid(): boolean {
        return this.getProperty('paid') === 'yes';
    }

    get isValidated(): boolean {
        return this.getProperty('servicecodesvalidated') === 'yes';
    }

    public validate() {
        this.setProperty('servicecodesvalidated', 'yes');
        this.update();
    }

    get type(): CNConsultationType {
        const theType = this.getProperty('StVaast_Type');
        if ( theType === null) {
            return CNConsultationType.Simple;
        }
        return theType;
    }

    set type(type: CNConsultationType) {
        this.setProperty('StVaast_Type', type);
    }

    set healthagentid(id: number) {
        this.setProperty('healthagentid', id.toString());
    }

    get healthagentid(): number {
        if (this.getProperty('healthagentid')) {
            return parseInt(this.getProperty('healthagentid'), 10);
        }
        return this.creatorid;
    }

    get havePrescription(): boolean {
        if (this.prescriptions) {
            return true;
        }
        const prescription = this.child$('SNItem.CNItem.CNPrescription');
        if (prescription) {
            return true;
        }
        return false;
    }

    get prescription(): CNPrescription {
        if (this.prescriptions) {
            return this.prescriptions[0];
        }
        return this.child$('SNItem.CNItem.CNPrescription') as CNPrescription;
    }

    set prescription(prescription: CNPrescription) {
        const addSub = this.addChild(prescription, false).subscribe(result => {
            if (this.prescriptions) {
                // update prescriptions too
                this.prescriptions = this.childs$('SNItem.CNItem.CNPrescription') as CNPrescription[];
            }
            setTimeout(() => {
                addSub.unsubscribe();
            });
        });
    }

    get haveContactService(): boolean {
        return (this.service) ? true : false;
    }

    get haveContactDocument(): boolean {
        return (this.documents) ? true : false;
    }

    get contactService(): CNContactService {
        return this.service;
    }

    addServiceCode(code: CNServiceCode): void {
        if (!this.service) {
            this.service = new CNContactService();
        }
        this.service.addCode(code);
    }

    removeServiceCode(code: CNServiceCode): void {
        if (this.service && this.service.codes) {
            const codeFound = this.service.codes.find(codeTmp => codeTmp.code === code.code);
            if (codeFound) {
                this.service.codes.splice(this.service.codes.indexOf(codeFound), 1);
            }
        }
    }

    get biometrics(): CNConsultationBiometrics {
        if (!this.biometricsCache) {
            this.biometricsCache = new CNConsultationBiometrics();
            if (this.getProperty('biometrics') !== null) {
                const bio = JSON.parse(this.getProperty('biometrics'));
                Object.assign(this.biometricsCache, bio);
            }
            this.itemchecksum = this.checksum;
        }
        return this.biometricsCache;
    }

    get ophtalmo(): CNConsultationOphtalmo {
        if (!this.ophtalmoCache) {
            this.ophtalmoCache = new CNConsultationOphtalmo();
            if (this.getProperty('ophtalmo') !== null) {
                const bio = JSON.parse(this.getProperty('ophtalmo'));
                Object.assign(this.ophtalmoCache, bio);
            }
            this.itemchecksum = this.checksum;
        }
        return this.ophtalmoCache;
    }

    get cardio(): CNConsultationCardio {
        if (!this.cardioCache) {
            this.cardioCache = new CNConsultationCardio();
            this.cardioCache.complaints = new CNConsultationCardioComplaints();
            this.cardioCache.clinicalexam = new CNConsultationCardioClinicalExam();
            this.cardioCache.complementaryexam = new CNConsultationCardioComplementary();
            this.cardioCache.conclusion = new CNConsultationCardioConclusion();
            if (this.getProperty('entries_json') !== null) {
                const entries = JSON.parse(this.getProperty('entries_json'));
                Object.assign(this.cardioCache, entries);
            }
            this.itemchecksum = this.checksum;
        }
        return this.cardioCache;
    }

    /**
     * Treatments specific calls
     */

    public treatments(type?: any): CNTreatment[] {
        if (!type) {
            return this.treatmentsCache;
        }
        const returned: CNTreatment[] = [];
        this.treatmentsCache.forEach(treatment => {
            if (treatment instanceof type) {
                returned.push(treatment);
            }
        });
        return returned;
    }

    public addTreatment(treatment: CNTreatment): void {
        this.treatmentsCache.push(treatment);
    }

    /**
     * Report request
     */

    public requestsFor(itemId: string): CNAnonymousReportRequest[] | undefined {
        if (!this.requests) {
            return undefined;
        }
        return this.requests.filter(request => request.getProperty('LinkedItemID') === itemId);
    }

    /**
     * ItemContainer interface
     * @returns string
     */

    get title(): string {
        return moment(this.date).format('DD/MM/YYYY');
    }

    /**
     * factory clone
     * @returns CNConsultation
     */

    public clone(): any {
        return new CNConsultation();
    }

    /**
     * JSON
     */

    public fromJson(json: any, emitLoaded?: boolean): void {
        super.fromJson(json, emitLoaded);
        // Get childs treatments
        this.childs$().forEach(child => {
            if (child.key.startsWith('SNItem.CNItem.CNTreatment')) {
                this.treatmentsCache.push(child as CNTreatment);
            }
        });
        if (typeof json.services !== 'undefined' && Array.isArray(json.services) && json.services.length !== 0) {
            // services
            this.service = new CNContactService();
            this.service.fromJson(json.services[0]);
        }
        if (typeof json.prescriptions !== 'undefined' && Array.isArray(json.prescriptions) && json.prescriptions.length !== 0) {
            // prescriptions
            this.prescriptions = [];
            json.prescriptions.forEach(jsonPrescription => {
                const prescription = new CNPrescription();
                prescription.fromJson(jsonPrescription);
                this.prescriptions.push(prescription);
            });
        }
        if (typeof json.documents !== 'undefined' && Array.isArray(json.documents) && json.documents.length !== 0) {
            // documents
            this.documents = [];
            json.documents.forEach(jsonDocument => {
                this.documents.push(SNItemFactory.getInstance().itemFromJson(jsonDocument));
            });
        }
        if (typeof json.documents !== 'undefined' && Array.isArray(json.documents) && json.documents.length !== 0) {
            // documents
            this.documents = [];
            json.documents.forEach(jsonDocument => {
                this.documents.push(SNItemFactory.getInstance().itemFromJson(jsonDocument));
            });
        }
        if (typeof json.reportrequests !== 'undefined' && Array.isArray(json.reportrequests) && json.reportrequests.length !== 0) {
            // documents
            this.requests = [];
            json.reportrequests.forEach(jsonRequest => {
                this.requests.push(SNItemFactory.getInstance().itemFromJson(jsonRequest));
            });
        }
        if (typeof json.healthagent !== 'undefined') {
            // services
            this.healthagent = SNItemFactory.getInstance().itemFromJson(json.healthagent);
        }
        this.itemchecksum = this.checksum;
//        console.log('item ' + this.id + ' ' + this.key + ' checksum', this.itemchecksum);
    }

    public toObj(deep = false): any {
        const obj = super.toObj(deep);
        if (this.treatmentsCache.length !== 0) {
            obj.treatments = [];
            this.treatmentsCache.forEach(treatment => {
                obj.treatments.push(treatment.toObj(deep));
            });
        }
        if (this.prescription) {
            obj.prescription = this.prescription.toObj(deep);
        }
        if (this.biometricsCache) {
            this.setProperty('biometrics', JSON.stringify(this.biometricsCache));
        }
        if (this.ophtalmoCache) {
            this.setProperty('ophtalmo', JSON.stringify(this.ophtalmoCache));
        }
        if (this.cardioCache) {
            this.setProperty('entries_json', JSON.stringify(this.cardioCache));
        }
        if (this.service) {
            obj.service = this.service.toObj();
        }
        return obj;
    }
}
